import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/index.scss';
import 'presentation/style/buProfile/buProfile.scss'
import { BuProfileContMain } from 'presentation/view/container/BuProfile/BuProfileContMain';

CommonEntrypoint(<BuProfileContMain/>)